import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { withRouter } from 'react-router-dom';
import moment from "moment";
import { useBoundStore } from '../../../store/useBoundStore';
import { Icon, Select } from 'antd';
import { BOBADMIN } from '../../../utils/Constants';
const { Option } = Select;

const PieChart = ({ response, className, history, userType }) => {
    const [hoveredSlice, setHoveredSlice] = useState(null);
    const { resetRSFSFilters, setRSFSFilters, RSFSCardFilters } = useBoundStore();

    if (!response || !response.datasets || response.datasets.length === 0) {
        return <div>Loading...</div>;
    }

    const { labels, datasets } = response;
    const { data, backgroundColor } = datasets[0];

    const routeToGrid = (label, data, index) => {
        const card = JSON.parse(localStorage.getItem('card'));
        let rsFSCardFilters = RSFSCardFilters.datemodified;
        // resetRSFSFilters();
        setRSFSFilters({
            datemodified: {
                start_date: rsFSCardFilters.start_date,
                end_date: rsFSCardFilters.end_date
            },
            selectedButton: 'AllBFiles',
        });
        const bucket = response && response.datasets && response.datasets[0] && response.datasets[0].buckets[index];
        if (card && card.user_id) {
            bucket.userName = card.userName;
            bucket.user_id = card.user_id;
            bucket.showName = true;
        }
        localStorage.setItem('card', JSON.stringify(bucket));
        history.push({
            pathname: "/dashboard/rsfs-grid",
            search: `?title=${encodeURIComponent(label)}`,
            state: { card: bucket }
        });

    }

    const chartOptions = {
        responsive: true,
        legend: {
            display: false,
        },
        maintainAspectRatio: false,
        onHover: (event, chartElement) => {
            const target = (event && (event.native ? event.native.target : event.nativeEvent ? event.nativeEvent.target : event.target));
            if (target) {
                if (chartElement && chartElement.length) {
                    target.style.cursor = 'pointer';
                } else {
                    target.style.cursor = 'default';
                }
            }
            if (chartElement.length > 0) {
                setHoveredSlice(chartElement[0]._index);
            } else {
                setHoveredSlice(null);
            }
        },
        onClick: (event, chartElement) => {
            if (chartElement.length > 0) {
                const card = JSON.parse(localStorage.getItem('card'));
                let rsFSCardFilters = RSFSCardFilters.datemodified;
                // resetRSFSFilters();
                setRSFSFilters({
                    datemodified: {
                        start_date: rsFSCardFilters.start_date,
                        end_date: rsFSCardFilters.end_date
                    },
                    selectedButton: 'AllBFiles',
                });

                const index = chartElement[0]._index;
                const label = response && response.datasets && response.datasets[0] && response.datasets[0].buckets[index].title;
                const bucket = response && response.datasets && response.datasets[0] && response.datasets[0].buckets[index];
                if (card && card.user_id) {
                    bucket.userName = card.userName;
                    bucket.user_id = card.user_id;
                    bucket.showName = true;
                }
                localStorage.setItem('card', JSON.stringify(bucket));
                history.push({
                    pathname: "/dashboard/rsfs-grid",
                    search: `?title=${encodeURIComponent(label)}`,
                    state: { card: bucket }
                });
                // history.push('/details', { label: labels[index], value: data[index] });
            }
        },
    };

    const styles = {
        customHeaderFlex: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
        },
        colorPrimary: {
            fontSize: 'large',
            fontWeight: '600',
            color: '#164897', // Example primary color
        },
        customTextDark: {
            fontSize: '13px',
            color: '#344767', // Example dark text color
        },
        customStylePie: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        listItem: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px',
            fontSize: '12px',
            cursor: 'pointer',
            transition: 'transform 0.2s ease-in-out', // Smooth transition
        },
        colorBox: {
            width: '18px',
            height: '18px',
            marginRight: '10px',
            borderRadius: '3px',
        },
        itemText: {
            fontSize: '12px',
            flex: 2,
            textAlign: 'left',
            fontWeight: 'bold',
            color: '#344767',
        },
        itemCount: {
            marginLeft: 'auto',
            textAlign: 'right',
            fontWeight: 'normal',
        },
        hrLine: {
            border: 'none',
            borderTop: '2px solid #F6F7F9',
            margin: '8px 0',
        },
    };

    return (
        <div>
            <div style={styles.customHeaderFlex}>
                <div style={styles.colorPrimary}>
                    Other Statistics
                </div>
                <div style={styles.customTextDark}>
                    {moment(response.dateFrom).format("MM/DD/YYYY")} - {moment(response.dateTo).format("MM/DD/YYYY")}
                </div>
            </div>

            {/* Search input below date and above legends */}
            {/* (Remove the entire <div> containing the Select input and Icon) */}

            <div style={styles.customStylePie}>
                <div style={{ width: '50%' }}>
                    <Pie data={response} options={chartOptions} height={260} />
                </div>
                <div style={{ width: '40%', marginTop: '10%' }}>
                    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                        {labels.map((label, index) => (
                            <React.Fragment key={index}>
                                <li
                                    style={{
                                        ...styles.listItem,
                                        transform: hoveredSlice === index ? 'scale(1.1)' : 'scale(1)',
                                        transition: 'transform 0.2s ease-in-out',
                                    }}
                                    onMouseEnter={() => setHoveredSlice(index)}
                                    onMouseLeave={() => setHoveredSlice(null)}
                                    onClick={() => routeToGrid(label, data, index)}
                                >
                                    <div
                                        style={{
                                            ...styles.colorBox,
                                            backgroundColor: backgroundColor[index],
                                        }}
                                    ></div>
                                    <span style={styles.itemText}>{label}</span>
                                    <span
                                        style={{
                                            ...styles.itemCount,
                                            fontWeight: hoveredSlice === index ? 'bold' : 'normal',
                                        }}
                                    >
                                        {data[index]}
                                    </span>
                                </li>
                                {/* Horizontal line after each legend */}
                                <hr style={styles.hrLine} />
                            </React.Fragment>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default withRouter(PieChart);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/shared-charts/PieChart.js